<template>
  <div class="lab" :class="meta.colorClass">
    <img v-if="meta.src" :src="meta.src" class="lab__img" alt="" />
    <feather-icon v-else :icon="meta.icon" size="16" />
  </div>
</template>

<script>
import { getLevelAvatarMeta } from "@core/utils/levelAvatars";

export default {
  name: "LevelAvatarBadge",
  props: {
    avatarKey: { type: String, default: "" },
  },
  computed: {
    meta() {
      return getLevelAvatarMeta(this.avatarKey);
    },
  },
};
</script>

<style scoped>
.lab {
  width: 38px;
  height: 38px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.lab__img {
  width: 22px;
  height: 22px;
  display: block;
  object-fit: contain;
}
</style>
